//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getActivitylist } from '@/api/youzheng.js'
import { firstJoin, homePage } from '@/api/jianianhua'
import { nowInDateBetwen } from '@/libs/utils'
import { Tab, Tabs, PullRefresh } from 'vant'
import { getaddlog } from '@/api/hgfw'
import axios from 'axios'
import config from '@/config'
export default {
  name: 'index',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [PullRefresh.name]: PullRefresh
  },
  props: {},
  data () {
    return {
      active: 0,
      stampnum: '',
      page: 1,
      rows: 8,
      url: 'http://192.168.1.106:8080/ftu/',
      partylist: [],
      type: 1,
      baseUrl: config.baseUrl,
      stampstatus: 0,
      isscratch: true,
      isLoading: false,
      num: '',
      nomore: false,
      moremsg: '点击加载更多',
      party: [
        {
          title: '今日活动'
        },
        {
          title: '主题活动'
        },
        {
          title: '地区活动'
        }
      ]
    }
  },
  created () { },
  mounted () {
    this.firstjoin()
    this.getlist()
    this.addLog()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
    gorule () {
      this.$router.push({ name: 'jianianhuarule' })
    },
    // 浏览量
    addLog () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120123
      })
    },
    firstjoin () {
      firstJoin({
        accountId: this.accountid
      }).then(res => {
        this.getinfor()
      })
    },
    getinfor () {
      homePage({
        accountId: this.accountid
      }).then(res => {
        this.stampnum = res.obj.num
        if (this.stampnum < 200) {
          this.isscratch = false
        }
        if (this.stampnum < 65) {
          this.stampstatus = 0
        } else if (this.stampnum >= 65 && this.stampnum < 550) {
          this.stampstatus = 1
        } else if (this.stampnum >= 550 && this.stampnum < 1500) {
          this.stampstatus = 2
        } else if (this.stampnum >= 1500 && this.stampnum < 2750) {
          this.stampstatus = 3
        } else {
          this.stampstatus = 4
        }
      })
    },
    linkdetail () {
      this.$router.push({ name: 'jianianhuadetaillist' })
    },
    linkstamp () {
      this.$router.push({ name: 'jianianhuastamp' })
    },
    linkscratch () {
      if (this.isscratch) {
        this.$router.push({ name: 'jianianhuascratch' })
      } else {
        this.$vux.toast.text('抱歉，您尚未获得本活动参与机会!')
      }
    },
    onClick (name, title) {
      this.page = 1
      this.partylist = []
      this.getlist(name)
    },
    getlist (name) {
      getActivitylist({
        page: this.page,
        rows: this.rows,
        acGenre: 2,
        acType: name || this.type
      }).then(res => {
        this.num = res.returnValue.total
        if (res.returnValue.rows.length > 0) {
          this.partylist = [...this.partylist, ...res.returnValue.rows]
          this.moremsg = '点击加载更多'
          this.nomore = false
        } else {
          this.moremsg = '没有更多了~'
          this.nomore = true
        }
        this.isLoading = false
        res.returnValue.rows.forEach((re, index) => {
          let partystatus = nowInDateBetwen(
            re.signstartdate.replace(/-/g, '/'),
            re.signenddate.replace(/-/g, '/')
          )
          if (partystatus == 1) {
            this.$set(this.partylist[index], 'iswork', true)
          } else {
            this.$set(this.partylist[index], 'iswork', false)
          }
        })
      })
    },
    linkactive (iswork, link) {
      if (iswork) {
        window.location.href = link
      }
    },
    onRefresh (index) {
      this.page = 1
      this.getlist(index)
    },
    loadmore (index) {
      if (!this.nomore) {
        this.moremsg = '加载中...'
        this.page++
        this.getlist(index)
      }
    }
  }
}
